/**
 * @see https://umijs.org/docs/max/access#access
 * */
// 存储用户有权限访问的路径
let userAccessPaths: string[] = [];

// 设置用户可访问路径的函数
export function setUserAccessPaths(paths: string[]) {
  // 确保路径格式统一
  userAccessPaths = paths;
}

export default function (initialState: { currentUser?: API.CurrentUser }) {
  const { currentUser } = initialState || {};

  return {
    canMember: true,
    canAdmin: currentUser && currentUser.identities === 1,
    canSuperAdmin: currentUser && currentUser.identities === 0,
    canAccessPath: (route: any) => {
      // 特殊路径处理
      const specialPaths = ['/user/login', '*', '/', '/404'];
      if (specialPaths.includes(route.path)) {
        return true;
      }

      // 超级管理员拥有所有权限
      // if (currentUser?.identities === 0) {
      //   return true;
      // }

      // 规范化路径进行比较
      // const normalizedPath = route.path.startsWith('/') ? route.path : `/${route.path}`;
      if (currentUser?.identities === 2 && route.path.includes('/user-management')) {
        return false;
      }
      return userAccessPaths.includes(route.path);
    },
  };
}
